import { Alert, Typography } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { frFR } from '@mui/x-data-grid/locales';
import { Country } from '../../../../models/supplierAdministration';
import { CustomPaper } from '../../styles';

type CountriesTabProps = {
	countries: Country[];
	loading: boolean;
	error: string | null;
}

const columns: GridColDef<Country>[] = [
	{ field: 'code', headerName: 'Code', flex: 0.3, minWidth: 120 },
	{ field: 'name', headerName: 'Pays', flex: 1, minWidth: 240 },
];

const CountriesTab = ({ countries, loading, error }: CountriesTabProps) => {
	return (
		<CustomPaper>
			<Typography variant="h5" color="primary" sx={{ mb: 2 }}>
				Pays
			</Typography>
			{error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
			<DataGrid
				rows={countries}
				columns={columns}
				loading={loading}
				initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
				pageSizeOptions={[25, 50, 100]}
				disableRowSelectionOnClick
				localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
				autoHeight
			/>
		</CustomPaper>
	);
};

export default CountriesTab;
